import Http from '../../containers/App/Http';
import store from '../../containers/App/store'
import {setProducts} from "../../redux/actions/productsActions";

export default class WPSites{

    addSite(formData){
        return Http.post("/wps/addSite",formData).then(async response => {
            if (response.data.status === 'failed')
                return response;

            return response;
        });
    }

}